<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6>Project Info</h6>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list class="site-info-list">
        <mat-list-item> 
          Installed Capacity: <span class="item-value"> &nbsp; {{solarConfig.totalInstalledCapacity}} kWp </span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>System Health: <mat-icon aria-hidden="false" aria-label="weather icon" class="Bosch-Ic-information" style="width: max-content"></mat-icon>: <span class="item-value"> &nbsp; {{sensorHealthMsg}} &nbsp;</span> <sup style="padding-bottom: 5px"> <span [ngClass]="(sensorHealth==='ON')?'dot-green':'dot-red'"></span></sup></mat-list-item>
      </mat-list>
  </mat-expansion-panel>